import { render, staticRenderFns } from "./labelBox.vue?vue&type=template&id=9cb4589e&scoped=true&"
import script from "./labelBox.vue?vue&type=script&lang=js&"
export * from "./labelBox.vue?vue&type=script&lang=js&"
import style0 from "./labelBox.vue?vue&type=style&index=0&id=9cb4589e&prod&lang=scss&"
import style1 from "./labelBox.vue?vue&type=style&index=1&id=9cb4589e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb4589e",
  null
  
)

export default component.exports